import { ReactNode } from "react";

import { MESSAGE } from "@/constants/message";
import useToast, { EToastType } from "@/hooks/ui/useToast";

import NotificationContent from "../notification/notificationContent";

const GET_TOAST_MESSAGE = (
  operation: "create" | "edit" | "delete",
  status: "success" | "duplicateError" | "generalError",
  additionalMessage?: string
) => {
  const output = {
    create: {
      success: (
        <NotificationContent
          title={MESSAGE.ADD_GROUP_PANEL_TITLE_SUCCESS}
          description={MESSAGE.ADD_GROUP_PANEL_DESCRIPTION_SUCCESS}
        />
      ),
      duplicateError: (
        <NotificationContent
          title={MESSAGE.ADD_GROUP_PANEL_TITLE_DUPLICATE_ERROR}
        >
          <p className="mb-0 mt-1" id="create-user-group-duplicate-error-toast">
            {MESSAGE.ADD_GROUP_PANEL_DESCRIPTION_PREFIX_DUPLICATE_ERROR}{" "}
            <strong>{additionalMessage}</strong>{" "}
            {MESSAGE.ADD_GROUP_PANEL_DESCRIPTION_SUFIX_DUPLICATE_ERROR}
          </p>
        </NotificationContent>
      ),
      generalError: (
        <NotificationContent
          title={MESSAGE.SOMETHING_WENT_WRONG}
          description={MESSAGE.SORRY_WE_ARE_EXPERIENCING_ISSUE}
        />
      )
    },
    edit: {
      success: (
        <NotificationContent
          title={MESSAGE.EDIT_GROUP_PANEL_TITLE_SUCCESS}
          description={MESSAGE.EDIT_GROUP_PANEL_DESCRIPTION_SUCCESS}
        />
      ),
      generalError: (
        <NotificationContent
          title={MESSAGE.EDIT_GROUP_PANEL_TITLE_FAILED}
          description={MESSAGE.EDIT_GROUP_PANEL_DESCRIPTION_FAILED}
        />
      )
    },
    delete: {
      success: (
        <NotificationContent
          title={MESSAGE.DELETE_GROUP_MANAGEMENT_TITLE_SUCCESS}
        >
          <span>
            {MESSAGE.DELETE_GROUP_MANAGEMENT_DESCRIPTION_SUCCESS}
            <span className="font-semibold mx-0.5">{additionalMessage}</span>
          </span>
        </NotificationContent>
      ),
      generalError: (
        <NotificationContent
          title={MESSAGE.DELETE_GROUP_MANAGEMENT_TITLE_FAILED}
          description={MESSAGE.DELETE_GROUP_MANAGEMENT_DESCRIPTION_FAILED}
        />
      )
    }
  };
  if (operation === "create") {
    return output.create[status] as ReactNode;
  } else {
    // For "edit" and "delete", only "success" and "generalError" are valid
    // If status is "duplicateError", fallback to generalError
    const validStatus = status === "success" ? "success" : "generalError";
    return output[operation][validStatus] as ReactNode;
  }
};

type ShowGroupManageMentType = {
  type: EToastType;
  operation: "create" | "edit" | "delete";
  status: "success" | "duplicateError" | "generalError";
  additionalMessage?: string;
  id?: string;
};
export const useGroupManagementToast = () => {
  const { showToast } = useToast();
  const showGroupManagementToast = ({
    type,
    operation,
    status,
    additionalMessage,
    id
  }: ShowGroupManageMentType) => {
    const message = GET_TOAST_MESSAGE(operation, status, additionalMessage);
    showToast({
      type,
      message,
      id,
      autoClose: 3000
    });
  };

  return { showGroupManagementToast };
};
